/**
 * @file common/util
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-07-06 Baidu
 */
import {envConfig} from '../common/envConfig';
export let getLoginUrl = () => {
    const {dwzBaiduDomain, passportUrl} = envConfig();
    // 移动端登录
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return `${dwzBaiduDomain}/console/login`;
    }

    const redirectUrl = `${dwzBaiduDomain}/bduss/get?url=${window.location.href}`;
    return `${passportUrl}/v2/?login&u=${encodeURIComponent(redirectUrl)}`;
};

export let getDwzConsoleUrl = () => {
    const {bceUrl} = envConfig();
    return `${bceUrl}/dwz/#/dwz/overview`;
};

export let getDwzConsolePackageUrl = () => {
    const {bceUrl} = envConfig();
    return `${bceUrl}/dwz/#/dwz/package/list`;
};
